import styles from './style.scss';

let toastTimeOut = null;

function renderNotification(text, type) {
	const target = document.getElementById('notification_container');

	const notification = document.createElement('div');
	notification.setAttribute('class', `${styles.toast} ${styles[type]} test_${type}`);
	notification.innerHTML = text;
	target.appendChild(notification);
}

function hide() {
	clearTimeout(toastTimeOut);
	let target = document.getElementById('notification_container').getElementsByTagName('div')[0];
	if (target) {
		target.remove();
	}
}


function show(text, type, callback = null) {

	document.getElementById('notification_container').setAttribute('class', styles.container);
	hide();
	if (!document.getElementById('notification_container').hasChildNodes()) {
		let renderTimeout = 5000;

		renderNotification(text, type);

		if (renderTimeout === -1) {
			return false;
		}

		toastTimeOut = setTimeout(function () {
			hide();
			if (typeof callback === "function") {
				callback();
			}

		}, renderTimeout);

		return true;
	}

	return false;
}

function warning(text, callback = null) {
	show(text, 'warning', callback);
}

function success(text, callback = null) {
	show(text, 'success', callback);
}

function error(text, callback = null) {
	show(text, 'error', callback);
}

export let notify = {
	success,
	warning,
	error
};